import { Button, Col, Form, Input } from 'antd'

import useEditPTO from 'hooks/pto/use-edit-pto'
import BaseInformation from 'modules/pto/form/base-information'
import CoTrustedPartners from 'modules/pto/form/co-trusted-partners'
import MetadataNFT from 'modules/pto/form/metadata-nft'
import Properties from 'modules/pto/form/properties'
import RentalInformation from 'modules/pto/form/rental-information'
import Timelines from 'modules/pto/form/timelines'
import UploadFile from 'modules/pto/form/upload-file'
import { notifyFormErrors } from 'utils/form-errors'

const Information = () => {
  const [form] = Form.useForm()

  const {
    edit,
    thumbnail,
    setThumbnail,
    thumbnails,
    setThumbnails,
    defaultPropertyType,
    propertyTypes,
    switchChecked,
    setSwitchChecked,
    ptoDetail,
    code,
    handleSubmit,
    handleCancel,
    handleEdit,
  } = useEditPTO({ form })

  return (
    <div className="p2p-create">
      <Form
        form={form}
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={handleSubmit}
        onFinishFailed={notifyFormErrors}
        scrollToFirstError={{
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        }}
      >
        <Col style={{ display: 'none' }} span={12}>
          <Form.Item
            label="Code"
            name="code"
            rules={[{ required: true, message: 'Please input the code!' }]}
          >
            <Input disabled placeholder="Enter the code" />
          </Form.Item>
        </Col>
        <div style={{ textAlign: 'start', paddingBottom: 10 }}>
          {!edit ? (
            <Button
              style={{ marginRight: 15, width: 100 }}
              key="edit"
              onClick={handleEdit}
              type="primary"
            >
              Edit
            </Button>
          ) : (
            <>
              <Button style={{ marginRight: 15, width: 100 }} key="back" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                style={{ width: 100 }}
                disabled={thumbnail.length === 0 || thumbnails.length === 0}
                key="submit"
                type="primary"
                htmlType="submit"
              >
                Save
              </Button>
            </>
          )}
        </div>

        <BaseInformation
          id={code}
          form={form}
          edit={edit}
          switchChecked={switchChecked}
          setSwitchChecked={setSwitchChecked}
          mode={'edit'}
        />

        <Properties
          form={form}
          edit={edit}
          propertyTypes={propertyTypes}
          defaultPropertyType={defaultPropertyType}
          mode={'edit'}
        />

        <RentalInformation form={form} edit={edit} mode={'edit'} />

        <Timelines form={form} edit={edit} mode={'edit'} />

        <MetadataNFT
          edit={edit}
          form={form}
          defaultThumbnail={ptoDetail?.metadata?.image}
          mode={'edit'}
          tokenizeId={ptoDetail?._id}
        />

        <UploadFile
          edit={edit}
          form={form}
          defaultThumbnail={thumbnail}
          defaultThumbnails={thumbnails}
          mode={'edit'}
          onUpload={(data) => {
            setThumbnail(data)
          }}
          onUploadMulti={(data) => {
            setThumbnails(data)
          }}
        />

        <CoTrustedPartners form={form} edit={edit} mode={'edit'} />
      </Form>
    </div>
  )
}

export default Information
